module.exports = __webpack_public_path__ + "img/order1.1e5a90d5.png";